import React from 'react';

const DepartureInfo = ({ from, to, date, type = 'DEPART' }) => {
  return (
    <div className="pb-11">
      <div className="text-[#316833] font-bold text-[16px] mb-1">{type}</div>
      <h2 className="text-[44px] font-[550] text-[#181e25] ">
        {from} to {to}
      </h2>
      <p className="text-[#50657c] text-[28px] font-[500] mb-4">{date}</p>
    </div>
  );
};

export default DepartureInfo;
